export const PLAN_OPTION = 'plan-option';
export const PR_PT = 'pt';
export const PR_PPT = 'ppt';
export const PR_SA = 'sum-assured';
export const PREMIUM = 'premium-amt';
export const FREQUENCY = 'frequency';